import { TPointCustomField } from '@project/view-models';

export function getCostExportValue(exportType: string, customField: TPointCustomField): string {
  switch (exportType) {
    case 'xlsx':
      return customField.value;
    default:
      return `${customField.currencySymbol} ${customField.value}`;
  }
}
